import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M26 8.6L20.4 3A3.7 3.7 0 0018 2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V11a3.7 3.7 0 00-1-2.4zm-7-4.2l5.6 5.6H19zM25 28H7V4h10v7a1 1 0 001 1h7z"/><path d="M17 16a1 1 0 01-1 1h-6a1 1 0 010-2h6a1 1 0 011 1zM23 24a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1zM23 20a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1z"/>';
export var FileOutlineSVG = function FileOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FileOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FileOutlineSVG);